var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Button, Form, Skeleton } from '@robinpowered/ui-kit';
import { useWatch } from 'react-hook-form';
import { useCallback } from 'react';
import { faPlus } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SpaceComponent } from './SpaceComponent';
import { SpaceDetailsProvider } from './SpaceDetailsContext';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
/* @TODO[Spaces] this is getting large clean it up */
export var EventSpaceWrapper = function (_a) {
    var isLoadingEvent = _a.isLoadingEvent, fetchingSpace = _a.fetchingSpace, eventPermissions = _a.eventPermissions, initialEvent = _a.initialEvent, checkSpaceDeletionPermission = _a.checkSpaceDeletionPermission, setCompletedSpaceRequestFormId = _a.setCompletedSpaceRequestFormId;
    var t = useTranslation('meetingRooms').t;
    var _b = useEventComposerGlobalContext(), setSpaceBookingOpen = _b.setSpaceBookingOpen, requestOnlySpace = _b.requestOnlySpace, setPendingSpaceSwap = _b.setPendingSpaceSwap, showSuggestedSpace = _b.showSuggestedSpace;
    var isSpaceRequestOnlyEvent = !!requestOnlySpace;
    var _c = __read(useWatch({
        name: ['spaces'],
    }), 1), spaces = _c[0];
    var onChangeSpace = useCallback(function (spaceId, spaceInviteeId) {
        setPendingSpaceSwap({ spaceId: spaceId, spaceInviteeId: spaceInviteeId });
        setSpaceBookingOpen(true);
    }, [setPendingSpaceSwap, setSpaceBookingOpen]);
    if (isLoadingEvent || showSuggestedSpace) {
        return null;
    }
    if (fetchingSpace) {
        return _jsx(Skeleton, {});
    }
    return (_jsxs(SpaceItemWrapper, { label: showSuggestedSpace ? null : t('create_event.space_heading'), children: [spaces === null || spaces === void 0 ? void 0 : spaces.map(function (space) {
                return (_jsx(SpaceDetailsProvider, { eventPermissions: eventPermissions, initialEvent: initialEvent, spaceId: space.id, setCompletedSpaceRequestFormId: setCompletedSpaceRequestFormId, children: _jsx(SpaceComponent, { spaceId: space.id, spaceInviteeId: space === null || space === void 0 ? void 0 : space.inviteeId, userCanRemoveSpace: !!(checkSpaceDeletionPermission === null || checkSpaceDeletionPermission === void 0 ? void 0 : checkSpaceDeletionPermission(!!space.isOrganizer)), onChangeSpace: onChangeSpace }) }, space.id));
            }), !isSpaceRequestOnlyEvent && (_jsx(Button, { onClick: function () { return setSpaceBookingOpen(true); }, type: (spaces === null || spaces === void 0 ? void 0 : spaces.length) ? 'text' : 'default', icon: _jsx(FontAwesomeIcon, { icon: faPlus, size: "xs" }), style: { alignSelf: 'flex-start' }, children: (spaces === null || spaces === void 0 ? void 0 : spaces.length)
                    ? t("spaces.add_another_space")
                    : t("spaces.add_space") }))] }));
};
var SpaceItemWrapper = styled(Form.Item)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-form-item-control-input-content {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n"], ["\n  .ant-form-item-control-input-content {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n"])));
export var SpaceInfoWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 12px;\n  border-top: ", ";\n"], ["\n  padding: 12px;\n  border-top: ", ";\n"])), function (_a) {
    var showBorder = _a.showBorder;
    return showBorder ? "1px solid rgba(0, 0, 0, 0.06)" : 'none';
});
var templateObject_1, templateObject_2;
